import { render } from "./day-three.vue?vue&type=template&id=498c781b"
import script from "./day-three.vue?vue&type=script&lang=js"
export * from "./day-three.vue?vue&type=script&lang=js"

import "./day-three.vue?vue&type=style&index=0&id=498c781b&lang=scss"
script.render = render

export default script